import React from 'react';
import glamorous from 'glamorous';
import { isEmpty, map } from 'lodash';

const FieldComponent = (props) => {
  const { title, example, description, presence, preExample, subsection } = props;
  return (
    <div data-subsection={subsection}>
      <h4>{title}</h4>
      {!isEmpty(description) && description}
      {!isEmpty(presence) &&
      <glamorous.Div css={{ marginTop: 5, marginBottom: 5 }}>
        {map(presence, p => (<div key={p}><strong>{p}</strong></div>))}
      </glamorous.Div>}
      {!isEmpty(preExample) && preExample}
      {!isEmpty(example) &&
      <div>
        <glamorous.Div css={{ marginTop: 8 }}>
          Example:
        </glamorous.Div>
        <pre>
          <code className="language-xml">
            {example}
          </code>
        </pre>
      </div>}
    </div>
  );
};

export default FieldComponent;


// WEBPACK FOOTER //
// ./src/views/static/import-documentation/field-description/field-component.js